import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'infra-cumulative_layout_shift-view';
/**
 * General event for the capturing Cumulative Layout Shift (CLS) metric.
 */
export function trackInfraCumulativeLayoutShiftView(name, loadType2, cls3, attribution4, manualOverrides) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        manualOverrides: manualOverrides,
        parameters: { name, loadType2, cls3, attribution4 },
    });
}
